module.exports = __webpack_public_path__ + "img/warning_icon.86003b7b.png";